import React, { FC, useState } from 'react';
import { Box, Button, Card, Typography, } from '@material-ui/core';
import DateTimePicker from "react-datetime-picker";
import { useDataProvider } from 'ra-core';
import { useNotify } from 'react-admin';

import { ReportDateParams } from '../../types/reports';
import Loader from '../common/loader';
import "./style.css";

interface State {
    startDate: Date;
    endDate: Date;
}

interface Props {
    redirectToReportList: () =>  void
}

const VoucherReport: FC<Props> = ({redirectToReportList}) => {
    const notify = useNotify()
    const dataProvider = useDataProvider()
    const [state, setState] = useState<State>({
        startDate: new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
        endDate: new Date(),
    });
    const [loading, setLoading] = useState(false);

    const setStartDate = (value: Date) => {
        setState({ ...state, startDate: value })
    }

    const setEndDate = (value: Date) => {
        setState({ ...state, endDate: value })
    }

    const createReport = async () => {
        const startDate = state.startDate.toISOString()
        const endDate = state.endDate.toISOString()

        if (startDate > endDate) {
            notify('The start date cannot be greater than the finish date.', 'error');
            return
        }

        try {
            setLoading(true);
            const params: ReportDateParams = { startDate, endDate };
            const result = await dataProvider.createVoucherReport(params);
            notify('Voucher report is being generated. Voucher report is accessible to download in the Report list tab', 'info');
            redirectToReportList();
        } catch(err) {
            if (typeof err === "object" && err !== null) {
                const anyErr = err as any;
                if (anyErr.response?.status === 504 || anyErr.status === 504) {
                    notify('This report takes a long time to generate. It will be available in Report list after a while.', 'error', false, false, 15000);
                    return;
                }
                if (anyErr.data?.error) {
                    notify(anyErr.data.error, "error");
                    return;
                }
                if (err instanceof Error && err.message) {
                    notify(err.message, "error");
                }
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Card elevation={0} className="reportsCardWrapper" >
            <Box display="flex" alignItems="center" justifyContent="flex-start" >
                <Box style={{ width: 250 }} paddingBottom="1em">
                    <Typography gutterBottom className="base-color">
                        Start date
                    </Typography>
                </Box>
                <form >
                    <Box position="absolute">
                        <DateTimePicker
                            value={state.startDate}
                            format={"dd-MM-y h:mm:ss a"}
                            onChange={setStartDate}
                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                            disableClock
                        />
                        <Box marginTop="1em" >
                        </Box>
                    </Box>
                </form>
            </Box>

            <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="2em">
                <Box style={{ width: 250 }} paddingBottom="1em">
                    <Typography gutterBottom className="base-color">
                        Finish date
                    </Typography>
                </Box>
                <form >
                    <Box position="absolute">

                        <DateTimePicker
                            value={state.endDate}
                            format={"dd-MM-y h:mm:ss a"}
                            onChange={setEndDate}
                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                            disableClock
                        />
                        <Box marginTop="1em" >
                        </Box>
                    </Box>
                </form>
            </Box>

            <Box style={{ width: '50%' }} marginTop='2rem' display="flex" justifyContent="space-between">
                <Button 
                    size="large" 
                    className="getReportsBtn" 
                    onClick={createReport} 
                    disabled={loading}
                    endIcon={loading ? <Loader small /> : null}
                >
                    Create
                </Button>
            </Box>
        </Card>
    )
}

export default VoucherReport